var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCigarBand = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M68.03 36.3v7.39c0 .7-.57 1.27-1.27 1.27H55.71c-1.63 2.53-4.48 4.21-7.71 4.21s-6.09-1.68-7.72-4.21H29.23c-.7 0-1.27-.57-1.27-1.27V36.3c0-.7.57-1.27 1.27-1.27h11.05c1.63-2.53 4.48-4.21 7.71-4.21s6.08 1.68 7.71 4.21h11.05c.7 0 1.27.57 1.27 1.27Z"
  })));
};
export default SvgCigarBand;